import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import T from 'components/common/translations/Translate';
import { connect } from 'react-redux';
import HeaderBack from 'components/components/account/components/HeaderBack';
import withRouter from 'components/components/common/withRouter';
import { setUserLogout } from 'components/actions/authActions';
import isWindow from 'components/common/helpers/isWindow';

class Pricing extends Component {

  render() {
    const { isLogged } = this.props;

    return (
      <div className="content content--lp content--lp-text">
        {isLogged &&
          <HeaderBack
            locale={this.props.locale}
            name="Help"
            link="routes.url.help"
            title="content.layout.sidebarAndHeader.backToHelpTitle"
            className="header-back--lp" />
        }

        <div className="row row--text">
          <div className="headline headline--subpage">
            <h1><T>content.landing.pricing.title</T></h1>
            <p><T>content.landing.pricing.desc</T></p>
          </div>

          <div className="price-list">
            <h4><T>content.landing.pricing.doorToDoor.title</T></h4>

            <table className="tab--pricing">
              <thead>
                <tr>
                  <th><T>content.landing.pricing.doorToDoor.column</T></th>
                  <th className="price"><T>content.landing.pricing.adults</T></th>
                  <th className="price"><T>content.landing.pricing.kids</T></th>
                </tr>
              </thead>

              <tfoot>
                <tr>
                  <td colSpan="3">
                    <p><T>content.landing.pricing.info</T></p>
                  </td>
                </tr>
              </tfoot>

              <tbody>
                <tr>
                  <td>Drammen</td>
                  <td>290</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Lier, Lierskogen, Reistad, Tranby</td>
                  <td>310</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Oslo Sentrum, Gamle Oslo, Sagene, Bjerke, Østensjø, Frogner, St Hanshaugen, Grünerlokka, Nordre Aker, Vestre Aker, Ullern, Høvik, Sandvika, Vøyenenga, Slependen, Haslum, Gjettum, Rud, Kolsås, Bekkestua, Jar, Eiksmarka, Fornebu, Østeras, Hosle, Blommenholm, Lysaker, Snarøya, Stabekk, Asker, Borgen, Nesbru, Hvalstad, Billingstad, Nesøya</td>
                  <td>370</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Grorud, Stovner, Alna, Nordstrand, Søndre Nordstrand, Vettre</td>
                  <td>390</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Strømmen, Skjetten, Fjellhamar, Lørenskog, Lillestrøm, Løvenstad, Nordbyhagen, Kjeller, Blystadlia, Rasta, Finstadjordet</td>
                  <td>400</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Hagan, Slattum, Skedsmokorset, Langhus, Trollåsen, Tårnåsen, Kolboten, Sofiemyr, Oppegård</td>
                  <td>430</td>
                  <td>170</td>
                </tr>
              </tbody>

            </table>

            <h4></h4>

            <table className="tab--pricing">
              <thead>
                <tr>
                  <th><T>content.landing.pricing.busStop.column</T></th>
                  <th className="price"><T>content.landing.pricing.adults</T></th>
                  <th className="price"><T>content.landing.pricing.kids</T></th>
                </tr>
              </thead>

              <tfoot>
                <tr>
                  <td colSpan="3">
                    <p><T>content.landing.pricing.info</T></p>
                  </td>
                </tr>
              </tfoot>

              <tbody>
                <tr>
                  <td>Horten prom/ferry/ferge</td>
                  <td>230</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Drammen Bangeløkka</td>
                  <td>220</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Drammen Togstasjon/Train station/Dworzec</td>
                  <td>290</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Asker, Lier</td>
                  <td>250</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Sande</td>
                  <td>320</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Oslo Bussterminal, Sjølyst, Lysaker, Oksenøyveien, Stabekk, Høvik</td>
                  <td>280</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td> Sandvika Circle K, Sandvika Bussterminal, Billingstad IKEA</td>
                  <td>300</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Blakstad Bunnpris</td>
                  <td>400</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Skedsmokorset Shell</td>
                  <td>420</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Tusenfryd</td>
                  <td>450</td>
                  <td>170</td>
                </tr>
              </tbody>
            </table>

            <h4><T>content.landing.pricing.doorToDoor.titleGardermoen</T></h4>

            <table className="tab--pricing">
              <thead>
                <tr>
                  <th><T>content.landing.pricing.doorToDoor.column</T></th>
                  <th className="price"><T>content.landing.pricing.adults</T></th>
                  <th className="price"><T>content.landing.pricing.kids</T></th>
                </tr>
              </thead>

              <tfoot>
                <tr>
                  <td colSpan="3">
                    <p><T>content.landing.pricing.info</T></p>
                  </td>
                </tr>
              </tfoot>

              <tbody>
                <tr>
                  <td>Oslo Sentrum, Gamle Oslo, Sagene, Bjerke, Østensjø, Frogner, St Hanshaugen, Grünerlokka, Nordre Aker, Vestre Aker, Ullern, Norstrand, Grorud, Stovner, Alna, Lillestrøm, Lørenskog, Skedsmokorset, Slattum </td>
                  <td>300</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Høvik, Sandvika, Vøyenenga, Slependen, Haslum, Gjettum, Rud, Kolsås, Bekkestua, Jar, Eiksmarka, Fornebu, Østeras, Hosle, Blommenholm, Lysaker, Snarøya, Stabekk, Nesbru, Billingstad, Nesøya</td>
                  <td>350</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Asker, Borgen, Hvalstad, Kolbotn, Sofiemyr, Langhus, Oppegård</td>
                  <td>390</td>
                  <td>170</td>
                </tr>
              </tbody>

            </table>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogout }
  )(Pricing));
